import { inject } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    CanMatchFn,
    Data,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
} from "@angular/router";

import { AuthGuardPermission } from "../api/auth-guard-permission";
import { AuthService } from "./auth.service";

export const permissionObjectKey = "permission";

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const permissionData = route.data[permissionObjectKey] as AuthGuardPermission;
    const returnUrl = state.url;
    return hasAuthUserAccessToThisRoute(permissionData, returnUrl);
};

export const AuthGuardMatch: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    if (route.data) {
        const permissionData = route.data[permissionObjectKey] as AuthGuardPermission;
        const returnUrl = `/${route.path}`;
        return hasAuthUserAccessToThisRoute(permissionData, returnUrl);
    } else {
        return true;
    }
};

export const hasAuthUserAccessToThisRoute = (permissionData: Data, returnUrl: string): boolean => {

    const authService = inject(AuthService);

    if (!authService.isAuthUserLoggedIn()) {
        showAccessDenied(returnUrl);
        return false;
    }

    if (!permissionData) {
        return true;
    }

    if (Array.isArray(permissionData.deniedRoles) && Array.isArray(permissionData.permittedRoles)) {
        throw new Error("Don't set both 'deniedRoles' and 'permittedRoles' in route data.");
    }

    if (Array.isArray(permissionData.permittedRoles)) {
        const isInRole = authService.isAuthUserInRoles(permissionData.permittedRoles);
        if (isInRole) {
            return true;
        }

        showAccessDenied(returnUrl);
        return false;
    }

    if (Array.isArray(permissionData.deniedRoles)) {
        const isInRole = authService.isAuthUserInRoles(permissionData.deniedRoles);
        if (!isInRole) {
            return true;
        }

        showAccessDenied(returnUrl);
        return false;
    }

    return true;
}

export const showAccessDenied = (returnUrl: string) => {
    const router = inject(Router);
    router.navigate(["/accessDenied"], { queryParams: { returnUrl: returnUrl } });
}
